import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: boolean = false;

const buyNowSlice = createSlice({
  initialState,
  name: "buynow",
  reducers: {
    setBuyNow: (state: boolean, action: PayloadAction<boolean>) => {
      return action.payload;
    },
  },
});

export const { setBuyNow } = buyNowSlice.actions;

export default buyNowSlice.reducer;
